import { ReportConfig } from './report-view/sparepart-report.config';
import { SPARE_PARTS_REPORT_CONFIG } from './report-view/sparepart-report.config';
import { EQUIPMENT_TAT_REPORT_CONFIG } from './report-view/equipment-tat.config';
import { MAINTENANCE_HISTORY_REPORT_CONFIG } from './report-view/maintenance-history.config';
import { PROCUREMENT_REPORT_CONFIG } from './report-view/procurement.config';
import { JOB_CARD_SUMMARY_REPORT_CONFIG } from './report-view/job-card-summary.config';
import { BACK_JOB_REPORT_CONFIG } from './report-view/back-job.config';
import { TECHNICIAN_EFFICIENCY_REPORT_CONFIG } from './report-view/technician-efficiency.config';
import { EQUIPMENT_SERVICEABILITY_REPORT_CONFIG } from './report-view/equipment-serviceability.config';
import { EQUIPMENT_DOWNTIME_REPORT_CONFIG } from './report-view/equipment-downtime.config';
import { PM_COMPLIANCE_REPORT_CONFIG } from './report-view/pm-compliance.config';
import { DELEGATION_REPORT_CONFIG } from './report-view/delegation.config';
import { USER_MASTER_LIST_REPORT_CONFIG } from './report-view/user-master-list.config';

export type ReportId =
  | 'spare-parts'
  | 'equipment-tat'
  | 'maintenance-history'
  | 'procurement'
  | 'job-card-summary'
  | 'back-job'
  | 'technician-efficiency'
  | 'equipment-serviceability'
  | 'equipment-downtime'
  | 'pm-compliance'
  | 'delegation'
  | 'user-master-list';

export type CategoryId = 'inventory' | 'maintenance' | 'delegation' | 'user';

export interface ReportRegistryEntry {
  id: ReportId;
  config: ReportConfig;
  routeParam: string;
  categoryId: CategoryId;
  exportReportName: string;
}

export const REPORT_REGISTRY: Record<ReportId, ReportRegistryEntry> = {
  'spare-parts': {
    id: 'spare-parts',
    config: SPARE_PARTS_REPORT_CONFIG,
    routeParam: 'spare-parts',
    categoryId: 'inventory',
    exportReportName: 'Spare-Parts-Report',
  },
  'equipment-tat': {
    id: 'equipment-tat',
    config: EQUIPMENT_TAT_REPORT_CONFIG,
    routeParam: 'equipment-tat',
    categoryId: 'inventory',
    exportReportName: 'Equipment-TAT-Report',
  },
  'maintenance-history': {
    id: 'maintenance-history',
    config: MAINTENANCE_HISTORY_REPORT_CONFIG,
    routeParam: 'maintenance-history',
    categoryId: 'inventory',
    exportReportName: 'Maintenance-History-Report',
  },
  procurement: {
    id: 'procurement',
    config: PROCUREMENT_REPORT_CONFIG,
    routeParam: 'procurement',
    categoryId: 'inventory',
    exportReportName: 'Procurement-Report',
  },
  'job-card-summary': {
    id: 'job-card-summary',
    config: JOB_CARD_SUMMARY_REPORT_CONFIG,
    routeParam: 'job-card-summary',
    categoryId: 'maintenance',
    exportReportName: 'Job-Card-Summary-Report',
  },
  'back-job': {
    id: 'back-job',
    config: BACK_JOB_REPORT_CONFIG,
    routeParam: 'back-job',
    categoryId: 'maintenance',
    exportReportName: 'Back-Job-Report',
  },
  'technician-efficiency': {
    id: 'technician-efficiency',
    config: TECHNICIAN_EFFICIENCY_REPORT_CONFIG,
    routeParam: 'technician-efficiency',
    categoryId: 'maintenance',
    exportReportName: 'Technician-Efficiency-Report',
  },
  'equipment-serviceability': {
    id: 'equipment-serviceability',
    config: EQUIPMENT_SERVICEABILITY_REPORT_CONFIG,
    routeParam: 'equipment-serviceability',
    categoryId: 'maintenance',
    exportReportName: 'Equipment-Serviceability-Report',
  },
  'equipment-downtime': {
    id: 'equipment-downtime',
    config: EQUIPMENT_DOWNTIME_REPORT_CONFIG,
    routeParam: 'equipment-downtime',
    categoryId: 'maintenance',
    exportReportName: 'Equipment-Downtime-Report',
  },
  'pm-compliance': {
    id: 'pm-compliance',
    config: PM_COMPLIANCE_REPORT_CONFIG,
    routeParam: 'pm-compliance',
    categoryId: 'maintenance',
    exportReportName: 'PM-Compliance-Report',
  },
  delegation: {
    id: 'delegation',
    config: DELEGATION_REPORT_CONFIG,
    routeParam: 'delegation',
    categoryId: 'delegation',
    exportReportName: 'Delegation-Report',
  },
  'user-master-list': {
    id: 'user-master-list',
    config: USER_MASTER_LIST_REPORT_CONFIG,
    routeParam: 'user-master-list',
    categoryId: 'user',
    exportReportName: 'User-Master-List-Report',
  },
};

export function getReportConfigByRouteParam(routeParam: string) {
  const entry = Object.values(REPORT_REGISTRY).find((r) => r.routeParam === routeParam);
  return entry?.config ?? null;
}

export function getReportConfigById(reportId: ReportId): ReportConfig | null {
  return REPORT_REGISTRY[reportId]?.config ?? null;
}

export function getRouteParamByReportId(reportId: ReportId): string | null {
  return REPORT_REGISTRY[reportId]?.routeParam ?? null;
}

export function getCategoryByRouteParam(routeParam: string): CategoryId | null {
  const entry = Object.values(REPORT_REGISTRY).find((r) => r.routeParam === routeParam);
  return entry?.categoryId ?? null;
}

export function getReportIdByRouteParam(routeParam: string): ReportId | null {
  const entry = Object.values(REPORT_REGISTRY).find((r) => r.routeParam === routeParam);
  return entry?.id ?? null;
}

export function getExportReportNameById(reportId: string): string {
  if (reportId in REPORT_REGISTRY) {
    return REPORT_REGISTRY[reportId as ReportId]?.exportReportName ?? 'report';
  }
  return 'report';
}
